import {EditPermissions} from '../../../../../../../shared/models';
import {newStepValue} from '../../../../../services/flowBuilder/utils/constants';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';

import {required} from '../../../../../../../shared/utils';
import {getEditTypes} from '../../../delegatorUtils';


export interface AskInputData {
    text: string;
    isPrivateVariable: boolean;
    validationPattern: string;
    varName: string;
    cancelInput: string;
    cancelMessage: string;
    next: string;
}


export class AskInput {

    menu: {} = {};
    step: {} = {};

    constructor() {
        this.menu = {
            'menuType': 'askInput',
        };
    }

    static toForm(stepData: { [index: string]: any }, editPermissions: EditPermissions): UntypedFormGroup {
        const {editMenuTextOnly, editFlows} = getEditTypes(editPermissions);
        return this.buildForm(this.getNodeData(stepData), editFlows);
    }

    private static buildForm(formData: AskInputData, editFlows: boolean): UntypedFormGroup {
        return new UntypedFormGroup({
            text: new UntypedFormControl({
                value: formData.text,
                disabled: !editFlows
            }, required('Text')),
            isPrivateVariable: new UntypedFormControl({
                value: formData.isPrivateVariable,
                disabled: !editFlows
            }),
            validationPattern: new UntypedFormControl({
                value: formData.validationPattern,
                disabled: !editFlows
            }),
            varName: new UntypedFormControl({
                value: formData.varName,
                disabled: !editFlows
            }, required('Variable name')),
            cancelInput: new UntypedFormControl({
                value: formData.cancelInput,
                disabled: !editFlows
            }),
            cancelMessage: new UntypedFormControl({
                value: formData.cancelMessage,
                disabled: !editFlows
            }),
            next: new UntypedFormControl(formData.next)
        });
    }

    private static getNodeData(stepData: { [index: string]: any }): AskInputData {
        const menu = stepData?.menu ? stepData?.menu : {};
        const input = menu?.input ? menu?.input : {};
        const cancel = menu?.cancel ? menu?.cancel : {};
        const next = stepData?.next ? stepData?.next : newStepValue;
        const text = menu?.text ? menu?.text : '';

        const {isPrivateVariable, validationPattern, varName} = input;
        const {cancelInput, cancelMessage} = cancel;

        return {
            text,
            isPrivateVariable: isPrivateVariable ? isPrivateVariable : false,
            validationPattern: validationPattern ? validationPattern : '',
            varName: varName ? varName : '',
            cancelInput: cancelInput ? cancelInput : '',
            cancelMessage: cancelMessage ? cancelMessage : '',
            next
        };
    }

    setNodeData(nodeData: AskInputData) {
        this.setCancel(nodeData);
        this.setInput(nodeData);

        this.step = {
            menu: this.menu,
            'type': 'menu',
            'next': nodeData.next,
            metadata: {
                nodeVersion: '1.0.0',
            }
        };
    }

    get nodeData() {
        return this.step;
    }

    setCancel(nodeData: AskInputData): void {
        if (nodeData.cancelMessage || nodeData.cancelInput) {
            this.menu = {
                ...this.menu,
                cancel: {}
            };
            if (nodeData.cancelMessage) {
                this.menu['cancel']['cancelMessage'] = nodeData.cancelMessage;
            }
            if (nodeData.cancelInput) {
                this.menu['cancel']['cancelInput'] = nodeData.cancelInput;
            }
        }
    }

    setInput(nodeData: AskInputData): void {
        this.menu = {
            ...this.menu,
            input: {}
        };

        if (nodeData.validationPattern) {
            this.menu['input']['validationPattern'] = nodeData.validationPattern;
        }

        this.menu['text'] = nodeData.text;
        this.menu['input']['varName'] = nodeData.varName;
        this.menu['input']['isPrivateVariable'] = nodeData.isPrivateVariable;
    }
}


// {
//     menu: {
//      text: '',
//      input: {
//          isPrivateVariable: false,
//          validationPattern: '',
//          varName: '',
//      },
//      cancel: {
//          cancelInput: '',
//          cancelMessage: '',
//      },
//      menuType: 'askInput',
//     },
//     type: 'menu',
//     next: newStepValue,
//     metadata: {},
// }
